import { render, staticRenderFns } from "./addSingleReceive.vue?vue&type=template&id=5bd90654&scoped=true&"
import script from "./addSingleReceive.vue?vue&type=script&lang=js&"
export * from "./addSingleReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd90654",
  null
  
)

export default component.exports